export const SET_UNITED_CARD_PND_FETCHING = 'SET_UNITED_CARD_PND_FETCHING';
	
export const SET_UNITED_CARD_PND_FETCHING_ERROR = 'SET_UNITED_CARD_PND_FETCHING_ERROR';
	
export const SET_UNITED_CARD_PND = 'SET_UNITED_CARD_PND';
	
export const CLEAN_UNITED_CARD_PND = 'CLEAN_UNITED_CARD_PND';
	
export const ABORT_UNITED_CARD_PND_REQUEST = 'ABORT_UNITED_CARD_PND_REQUEST';




// WEBPACK FOOTER //
// ./src/redux_related/unitedCardPND/actions.js